<!--=============================
=            AVATARS            =
==============================-->

<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Avatars</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Avatar With Tooltip</div>
          <div slot="card-body">
            <div class="media">
              <a
                class="mr-2"
                href="#"
                data-toggle="tooltip"
                data-placement="top"
                title="Russell Jones"
              >
                <img
                  src="../../assets/img/users/user-4.jpg"
                  alt="user"
                  class="rounded-circle thumb-md"
                />
              </a>
              <a
                class="mr-2"
                href="#"
                data-toggle="tooltip"
                data-placement="top"
                title="Otis Gomez"
              >
                <img
                  src="../../assets/img/users/user-4.jpg"
                  alt="user"
                  class="rounded-circle thumb-md"
                />
              </a>
              <a
                class="mr-2"
                href="#"
                data-toggle="tooltip"
                data-placement="top"
                title="Frank Osborn"
              >
                <img
                  src="../../assets/img/users/user-4.jpg"
                  alt="user"
                  class="rounded-circle thumb-md"
                />
              </a>
              <a
                class="mr-2"
                href="#"
                data-toggle="tooltip"
                data-placement="top"
                title="Dorothy Key"
              >
                <img
                  src="../../assets/img/users/user-4.jpg"
                  alt="user"
                  class="rounded-circle thumb-md"
                />
              </a>
              <a
                class="mr-2"
                href="#"
                data-toggle="tooltip"
                data-placement="top"
                title="Joseph Cross"
              >
                <img
                  src="../../assets/img/users/user-4.jpg"
                  alt="user"
                  class="rounded-circle thumb-md"
                />
              </a>
              <a
                class="mr-2"
                href="#"
                data-toggle="tooltip"
                data-placement="top"
                title="Shari Krieger"
              >
                <img
                  src="../../assets/img/users/user-4.jpg"
                  alt="user"
                  class="rounded-circle thumb-md"
                />
              </a>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Avatar Size</div>
          <div slot="card-body">
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-xl rounded" />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-lg rounded" />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-md rounded" />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-sm rounded" />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-xs rounded" />
            </a>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Square Shape Avatar</div>
          <div slot="card-body">
            <a class="user-avatar mr-2" href="#">
              <img
                src="../../assets/img/users/user-10.jpg"
                alt="user"
                class="thumb-xl rounded-circle"
              />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img
                src="../../assets/img/users/user-10.jpg"
                alt="user"
                class="thumb-lg rounded-circle"
              />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img
                src="../../assets/img/users/user-10.jpg"
                alt="user"
                class="thumb-md rounded-circle"
              />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img
                src="../../assets/img/users/user-10.jpg"
                alt="user"
                class="thumb-sm rounded-circle"
              />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img
                src="../../assets/img/users/user-10.jpg"
                alt="user"
                class="thumb-xs rounded-circle"
              />
            </a>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Size</div>
          <div slot="card-body">
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-xl rounded" />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-lg rounded" />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-md rounded" />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-sm rounded" />
            </a>
            <a class="user-avatar mr-2" href="#">
              <img src="../../assets/img/users/user-5.jpg" alt="user" class="thumb-xs rounded" />
            </a>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
  <!-- WIDGETS CARDS -->
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  }
};
</script>

<!--====  End of AVATARS  ====-->
